<template>
  <div>

    <div>
      <div class="container custom-body-width">
        <div class="row">

            <div class="col-xs-12 register-box information">



                <!-- <h1 class="red-heading bold m-t-md m-b-md">UPGRADE TO KYC</h1>
    <p>
      <b>KYC Verification</b><br/>
      To upgrade your account to KYC, Please provide the following documents for our face to face verification

    </p>

    <ul class="m-t-md m-b-md">
      <li>
        For Malaysian: <b>Original MyKad</b>
      </li>
      <li>
        For Foreigner: <b>Original Passport</b> and <b>Employment visa</b>
      </li>
    </ul>



    <p>
      Collection of the identification documents can be arranged, kindly contact our Customer Care Consultant at:
      <br/>
      <br/>
      Tel: 1300888606<br/>
      Email: customercare@eremit.com.my
    </p>
    <p>
      Please email to customercare@eremit.com.my with subject "<b>Document Collection</b>".
    </p>
    <ul class="m-t-md m-b-md">
      <li>1. Residence/Work place address</li>
      <li>2. Mobile number</li>
      <li>3. Date & time</li>
    </ul>
    <p>
      You may also visit any of our nearest branch, for identity Verification Process: <a style="color:blue;font-weight:bold" href="http://eremit.com.my/contact-us-branch-location.aspx" target="_blank"> Branch Address</a>
    </p>

    <p>
      Our Branch are open every day(including Public Holiday) form 9:00am to 6:00pm.
    </p>

    <p class="text-center m-b-md m-t-md">
                    <a target="_blank" :href="vModel.Url" id="_upgrade_to_kyc_detail" class="btn btn-danger btn-icon btn-icon-standalone btn-icon-standalone btn-lg">
                        <i class="fas fa-file-pdf-o"></i>
                        <span>Download Registration Form</span>
                    </a>
    </p> -->

                <div class="ekyc_mobile">
                    <p>
                        To increase your account limit, a face-to-face verification is needed to comply with regulatory
                        procedures.
                    </p>
                    <br>
                    <div class="from_part">
                        <div> From: </div>
                        <ul>
                            <li>
                                <span> Malaysian or Expatriate </span>
                                <strong> Transaction Limit: RM 30,000/day </strong>
                            </li>
                            <li>
                                <span> Migrant Worker/Others </span>
                                <strong> Transaction Limit: RM 5,000/month </strong>
                            </li>
                        </ul>
                    </div>
                    <!--end From-part-->

                    <div class="trns_limit">
                        To Transaction Limit: RM 50,000/day
                    </div>
                    <div class="sml_note">

                        You may visit any of our branches nationwide daily from 9:00am-5:00pm
                    </div>
                    <div class="bottom_part">
                        <p>Do bring along these original documents for the verification purposes </p>
                        <div class="red_color_list">
                            <span> i) Mykad (Malaysian)</span>
                            <span> ii) Passport (Foreigners) </span>
                        </div>
                        <div class="sml_note note">
                            <span>*Note: </span>
                            We also provide on-site verification by visiting your place of residence or office. Kindly contact us
                            at +603-8313 8606 & +603-7724 2070 to
                            schedule an appointment
                        </div>
                        <div class="dwn_btn">
                            <a target="_blank" :href="vModel.Url">Download Registration Form </a>
                        </div>

                    </div>


                </div>
                <!--end wrapper ekyc_moile-->


            </div>
        </div>

      </div>
      <!-- eo row -->
    </div>
    <!-- eo container -->
  </div>


</template>
<script>
  import Vue from "vue"
  import CommonService from "../services/common";
  export default {
    name: "UpgradeToKYC",
    beforeRouteEnter(to, from, next) {
      next(p => {
        p.vModel.Url = CommonService.getBaseUrl("customer/upgradetokyc/" + to.params.token);
      });
    },
    created() {
    },
    mounted() {
    },
    data() {
      return {
        vModel: {
          Url: null
        }
      };
    },
    methods: {
    }
  };
</script>
<style>
  body {
    background: #FAFBFD;
  }
</style>
<style scoped>
  	 
		.ekyc_mobile {
    padding: 15px;
    margin: 0 auto;
    display: block;
}

.from_part ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.from_part ul li span {
    display: block;
    font-weight: bold;
    color: #3C4C5F;
}

.from_part ul li {
    margin-bottom: 21px;
    position: relative;
    padding-left: 50px;
}

.from_part ul li strong {
    color: #E20000;
}

.from_part ul li:before {
    content: '';
    height: 30px;
    width: 30px;
    background: #3C4C5F;
    position: absolute;
    border-radius: 50%;
    color: #fff;
    left: 11px;
    line-height: 30px;
    top: 5px;
    text-align: center;
    font-weight: bold;
}

.from_part ul li:first-child:before {
    content: '1';
}
.from_part ul li:last-child:before{
    content :"2"
}
.trns_limit {
    max-width: 400px;
    margin: 0 auto;
    background: #3C4C5F;
    padding: 15px;
    border-radius: 5px;
    color: #fff;
    text-align: center;
}

.sml_note {
    margin: 15px 0;
    font-size: 90%;
    font-style: italic;
}

.ekyc_mobile {
    color: #3C4C5F;
}

.red_color_list {
    margin: 11px 0;
}

.red_color_list span {
    display: block;
    color: #E20000;
    font-weight: bold;
    margin-bottom: 6px;
}

.dwn_btn {
    max-width: 400px;
    margin: 0 auto;
    background: #E20000;
    padding: 15px;
    border-radius: 5px;
    color: #fff;
    margin-top: 50px;
    text-align: center;
}

.dwn_btn a {
    color: #fff;
    text-transform: uppercase;
    text-decoration: none;
    font-weight: bold;
}
</style>
